import { JSX, lazy, Suspense, type ComponentType, type LazyExoticComponent } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { RELAYER_REGISTRATION_PATHS } from './constants';

function lazyNamed<T extends ComponentType<any>>(
  importFn: () => Promise<Record<string, T>>,
  exportName: string
): LazyExoticComponent<T> {
  return lazy(() => importFn().then((module) => ({ default: module[exportName] as T })));
}

function withShell(element: JSX.Element): JSX.Element {
  return (
    <div style={{ minHeight: '100vh', padding: '40px 20px 20px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', width: '100%' }}>
        <Suspense fallback={<div aria-busy="true">Loading…</div>}>{element}</Suspense>
      </div>
    </div>
  );
}

const Requirements = lazyNamed(() => import('./screens/Requirements'), 'Requirements');
const RelayerUrl = lazyNamed(() => import('./screens/RelayerUrl'), 'RelayerUrl');
const EnsIdentifier = lazyNamed(() => import('./screens/EnsIdentifier'), 'EnsIdentifier');
const Workers = lazyNamed(() => import('./screens/Workers'), 'Workers');
const ReviewRegister = lazyNamed(() => import('./screens/ReviewRegister'), 'ReviewRegister');

export function getRelayerRegistrationRoutes(): JSX.Element {
  return (
    <>
      <Route
        path="/"
        element={<Navigate to={RELAYER_REGISTRATION_PATHS.requirements} replace />}
      />
      <Route
        path={RELAYER_REGISTRATION_PATHS.base}
        element={<Navigate to={RELAYER_REGISTRATION_PATHS.requirements} replace />}
      />
      <Route
        element={withShell(<Requirements />)}
        path={RELAYER_REGISTRATION_PATHS.requirements}
      />
      <Route element={withShell(<RelayerUrl />)} path={RELAYER_REGISTRATION_PATHS.relayerUrl} />
      <Route
        element={withShell(<EnsIdentifier />)}
        path={RELAYER_REGISTRATION_PATHS.ensIdentifier}
      />
      <Route element={withShell(<Workers />)} path={RELAYER_REGISTRATION_PATHS.workers} />
      <Route element={withShell(<ReviewRegister />)} path={RELAYER_REGISTRATION_PATHS.review} />
      <Route
        path="*"
        element={<Navigate to={RELAYER_REGISTRATION_PATHS.requirements} replace />}
      />
    </>
  );
}
